<script>
  import { userStore } from "../../../stores/user.store.js";
  import { tempStore } from "../../../stores/temp.store";

  import Icon from "../../../components/Icon/Icon.svelte";
  import { editaciaUzivatela } from "../../../api/user";
  import get from "get-value";

  import { viditelnostTabu } from "../sidebarLeft.func";

  const kodMenu = "nastaveniaUctu";
  let open = false;

  const unsubscribe = tempStore.subscribe((value) => {
    viditelnostMenu(value);
  });

  function viditelnostMenu(value) {
    let menu = get(value, "menu");
    open = kodMenu === menu;
  }

  const u = userStore.getUser();
  let id = u.user_id;
  let nove_heslo, nove_heslo_kontrola, stare_heslo;
  let tlacitkoOdoslat = "Uložiť";
  let messages = { errors: [], successes: [] };
  let form;

  async function upravUdaje(e) {
    tlacitkoOdoslat = "Ukladanie .";
    messages = { errors: [], successes: [] };
    let count = 0;
    let interval = setInterval(() => {
      if (count % 3 === 0) {
        count = 1;
      } else {
        count++;
      }
      tlacitkoOdoslat = "Ukladanie " + ".".repeat(count);
    }, 300);

    const formData = new FormData(form);
    const data = {};
    for (let field of formData) {
      const [key, value] = field;
      data[key] = value;
    }
    data.id = id;
    const loginResponse = await editaciaUzivatela(data);
    messages.errors = loginResponse.errors;
    messages.successes = loginResponse.successes;
    clearInterval(interval);
    tlacitkoOdoslat = "Uložiť";
  }
</script>

<!-- Tab map notes start -->
<div
  class="sidebar__tab sidebar__tab--map"
  data-tab="4"
  class:js-tab--open={open}
>
  <div
    class="sidebar__close"
    on:click|preventDefault={() => viditelnostTabu(kodMenu)}
  >
    <Icon kod="012" />
  </div>
  <div class="sidebar__wrapper">
    <h6 class="sidebar__heading">Nastavenia účtu</h6>
    <form on:submit|preventDefault={upravUdaje} bind:this={form}>
      <div style="margin-bottom: 64px;">
        <!-- Input start -->
        <div>
          <label class="input__label" for="login">Prihlasovacie meno</label>
          <input
            type="text"
            id="login"
            class="input input-margin"
            readonly
            disabled
            value={get(u, "options.user.login", "")}
          />
        </div>
        <!-- Input end -->

        <!-- Input start -->
        <div>
          <label class="input__label" for="name">Meno</label>
          <input
            type="text"
            id="name"
            class="input input-margin"
            readonly
            disabled
            value={get(u, "options.user.name", "")}
          />
        </div>
        <!-- Input end -->

        <!-- Input start -->
        <div>
          <label class="input__label" for="email">Email</label>
          <input
            type="email"
            id="email"
            class="input input-margin"
            readonly
            disabled
            value={get(u, "options.user.email", "")}
          />
        </div>
        <!-- Input end -->
      </div>
      <!-- Input start -->
      <div>
        <label class="input__label" for="pass-1"> Nové heslo </label>
        <input
          type="password"
          id="pass-1"
          class="input input-margin"
          placeholder="Min. 8 znakov"
          name="nove_heslo"
          bind:value={nove_heslo}
        />
      </div>
      <!-- Input end -->

      <!-- Input start -->
      <div>
        <label class="input__label" for="pass-2"> Zopakovať nové heslo </label>
        <input
          type="password"
          id="pass-2"
          class="input input-margin"
          placeholder="Min. 8 znakov"
          name="nove_heslo_kontrola"
          bind:value={nove_heslo_kontrola}
        />
      </div>
      <!-- Input end -->

      <!-- Input start -->
      <div>
        <label class="input__label" for="pass-0"> Aktuálne heslo </label>
        <input
          type="password"
          id="pass-0"
          class="input input-margin"
          placeholder="Zadajte aktuálne heslo"
          name="stare_heslo"
          bind:value={stare_heslo}
        />
      </div>
      <!-- Input end -->

      <div id="response">
        {#if messages.errors || messages.successes}
          {#each messages.errors as error}
            <div class="error">{error}</div>
          {/each}
          {#each messages.successes as success}
            <div class="success">{success}</div>
          {/each}
        {/if}
      </div>
      <input type="submit" class="btn btn--block" value={tlacitkoOdoslat} />
    </form>
  </div>
</div>

<!-- Tab map notes end -->
<style>
  #response {
    margin-bottom: 20px;
    text-align: center;
    font-size: 17px;
  }
  #response .error {
    color: #c24141;
  }

  #response .success {
    color: #008000;
  }
</style>
